import {Group, GroupBasic , GroupDetails, LdapTreeNode} from '@/models/group'
import {AssignmentPerType} from '@/models/assignments'
import BaseService from '@/services/BaseService'

export class GroupService extends BaseService<Group|GroupBasic> {
  constructor() {
    super('groups/')
  }

    public async get<TParam extends boolean, Treturn extends TParam extends true ? GroupBasic : Group>(basic?: TParam): Promise<Treturn[]> {
        const result = await this.instance.get(this.resourcePath,
          {
            params: {
              basic,
            },
          })
        return result.data
    }

    public async fetchGroupStatus(groupId: number): Promise<GroupDetails> {
        const result = await this.instance.get(this.resourcePath + groupId + '/status/')
        return result.data
    }
    public async fetchGroupDetailAssignment(groupId: number): Promise<AssignmentPerType> {
        const result = await this.instance.get(this.resourcePath + groupId + '/assignments/')
        return result.data
    }
    public async fetchLdapTree(): Promise<LdapTreeNode[]> {
        const result = await this.instance.get('ldap-tree/')
        return result.data
    }
}

export default new GroupService()
